import React from 'react';
import styled from 'styled-components';
import { Row, SPWDeleteButton } from 'spw-shared/globalComponents';
import { Dialog, DialogContent, DialogProps } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { ErrorMessage } from '../styles';

export const ConfirmUnsavedDialogContent = styled(DialogContent)`
  && {
    padding: 0 24px;
  }

  & .min-width-88 {
    min-width: 88px;
    padding-left: 12px;
    padding-right: 12px;
  }
`;

export const DialogActionButtonsContainer = styled(Row)`
  padding: 24px 0 24px 0;
`;

export const DiscardChangesButton = styled(SPWDeleteButton)`
  && {
    white-space: nowrap;
  }
`;

export const RenameScenarioDialog = withStyles({
  root: {
    '& .MuiPaper-root': {
      minWidth: 390,
      overflowY: 'auto',
    },
  },
})((props: DialogProps) => <Dialog {...props} disableScrollLock />);

export const SelectLabel = styled.div`
  && {
    white-space: nowrap;
  }
`;

export const ScenarioNameErrorMessage = styled(ErrorMessage)`
  margin-top: 3px;
  font-size: 12px;
  line-height: 20px;
`;
